import { DynamicGrid, DynamicGridField } from "./dynamicGrid.js"
import { TextBox } from "./textBox.js"
import { CheckBox, CheckBoxStatus } from "./checkBox.js"
import { ComboBox, ComboBoxField } from "./comboBox.js"
import { IsNumericTextBox, NumericTextBoxField } from "./isNumericTextBox.js"
import { DatePicker } from "./datePicker.js"
import { IsPanelbarDetails, IsPanelbarDetailsField } from "./isPanelbarDetails.js"
import { DropDownList, DropDownListField } from "./dropDownList.js"
import { MultiSelect, MultiSelectField } from "./multiSelect.js"
import { ListBox, ListBoxSelectField } from "./listBox.js"
import { IsGrid, IsGridField } from "./isGrid.js"
import { DateTimePicker } from "./dateTimePicker.js"
import { IsTimeTextBox, MultipleCheckBoxesField, TimeTextBoxField } from "./isTimeTextBox.js"
import { MultipleCheckBoxes } from "./multipleCheckBoxes.js"
import { TimePicker } from "./timePicker.js"
import { GetNextNumber, GetNextNumberField } from "./getNextNumber.js"
import { ColorPicker } from "./colorPicker.js"
import { HTMLEditor } from "./htmlEditor.js"
import { Dynamic, DynamicProps } from "./dynamic.js"
import { IsSearchField, IsSearchFieldField } from "./isSearchField.js"
import { MultipleRadioButtons, MultipleRadioButtonsField } from "./multipleRadioButtons.js"
import { Label } from "./label.js"
import { ImageDocument, ImageDocumentField } from "./imageDocument.js";
import { Statistic, StatisticField } from "./statistic.js";
import { SortableList, SortableListField } from "./sortableList.js";
import { Helper } from "../util/helper.js";
import { MetaDataHelper } from "../util/metaDataHelper.js";
import { MaskedInput, MaskedInputField } from "./maskedInput.js";
import { TranslationTextBox } from "./translationTextBox.js";
import { ProgressBar, ProgressBarField } from "./progressBar.js"
import { HiddenMemo } from "./hiddenMemo.js"
import { NodaPeriodeNumericTextBox, NodaPeriodeNumericTextBoxField } from "./nodaPeriodeNumericTextBox.js"
import { EmailTextBox } from "./emailTextbox.js"
import { EditNachschlag } from "./editNachschlag.js"
import { CommonAppBaseProps } from "./commonApp.js"
import { BaseField } from "./baseComponentProps.js"
import React from "react";
export class Field extends React.Component<FieldProps, any>{
    private renderField() {

        let value = this.props.field.model != null && this.props.field.model.indexOf("entity.") !== -1 ?
            MetaDataHelper.getFieldValue(this.props.entity, this.props.field.model)
            : this.props.handleEval(this.props.field.model);

        // KT - warum wird null mit "" ersetzt? Ich benutze manchmal null - z.B. für die Vererbung der Werte bei TaskGroup
        if (typeof value === "undefined") {
            value = "";
        }

        switch (this.props.field.type) {
            case "editNachschlag":
                return this.renderNachschlag();
            case "textbox":
                if (!Helper.hasValue(value))
                    value = "";
                return this.renderTextBox(this.props.field, value);
            case "email":
            case "emailtextbox":
                return this.rederEmailTextBox(this.props.field, value);
            case "translationTextBox":
                return this.renderTranslationTextBox(this.props.field, value);
            case "checkbox":
                return this.renderCheckBox(this.props.field, value);
            case "kendo-combo-box":
                return this.renderComboBox(this.props.field, value, this.props.onDataLoaded, this.props.handleEval);
            case "is-search-field":
                return this.renderIsSearchField(this.props.field, value, this.props.handleEval, this.props.handleIsSearchFieldFullObjectModel, false);
            case "is-multiple-radio-buttons":
                return this.renderIsMultipleRadioButtons(this.props.field, value, this.props.handleEval, this.props.onDataLoaded);
            case "is-panelbar-details":
                return this.renderIsPanelbarDetails(this.props.field, value, this.props.handleEval, this.props.onDataLoaded);
            case "is-numeric-text-box":
                return this.renderNumericTextBox(this.props.field, value, this.props.handleEval);
            case "kendo-date-picker":
                return this.renderDatePicker(this.props.field, value);
            case "kendo-date-time-picker":
                return this.renderDateTimePicker(this.props.field, value, this.props.handleEval);
            case "kendo-drop-down-list":
                return this.renderDropDownList(this.props.field, value, this.props.onDataLoaded, this.props.handleEval);
            case "kendo-multi-select":
                return this.renderMultiSelect(this.props.field, value, this.props.onDataLoaded);
            case "kendo-list-box":
                return this.renderListBox(this.props.field, value, this.props.onDataLoaded);
            case "is-grid":
                return this.renderIsGrid(this.props.field, value);
            case "is-search-multi-select-field":
                return this.renderIsSearchField(this.props.field, value, this.props.handleEval, this.props.handleIsSearchFieldFullObjectModel, true);
            case "label":
                return this.renderLabel(this.props.field, value, this.props.handleEval);
            case "is-time-text-box":
                return this.renderIsTimeTextBox(this.props.field, value);
            case "is-multiple-check-boxes":
                return this.renderIsMultipleCheckBoxes(this.props.field, value, this.props.onDataLoaded);
            case "kendo-time-picker":
                return this.renderTimePicker(this.props.field, value);
            case "is-get-next-number":
                return this.renderGetNextNumber(this.props.field, value, this.props.onDataLoaded, this.props.handleEval);
            case "kendo-color-picker":
                return this.renderColorPicker(this.props.field, value);
            case "htmlEditor":
                return this.renderHTMLEditor(this.props.field, value);
            case "dynamic":
                return this.renderDynamic(this.props.field, value, this.props.handleEval);
            case "statistic":
                return this.renderStatistic(this.props.field, value, this.props.handleEval);
            case "is-sortable-list":
                return this.renderSortableList(this.props.field, value, this.props.handleEval);
            case "is-dynamic-grid":
                return this.renderIsDynamicGrid(this.props.field, value, this.props.onDataLoaded, this.props.handleEval);
            case "image-document":
                return this.renderImageDocument(this.props.field, value);
            case "masked-input":
                return this.renderMaskedInput(this.props.field, value);
            case "kendo-progress-bar":
                return this.renderProgressBar(this.props.field, value);
            case "noda-periode-numeric-textboxes":
                return this.renderNodaPeriodeNumericTextBox(this.props.field, value);
            case "hidden-memo":
                return this.renderHiddenMemo(this.props.field, value);
            case "checkbox-status":
                return this.renderCheckBoxStatus(this.props.field, value);
            default:
                return <div>NOT IMPLEMENTED {this.props.field.type}</div>;
        }
    }

    private renderDisabled() {
        const entity = this.props.entity;
        const field = this.props.field;

        const notNewCantWrite = (!entity.IsNew && !entity.RecordRight.CanWrite);
        const isBoolReadOnly = (typeof (field.readOnly) !== "string" && field.readOnly);
        const isFunctionReadOnly = typeof field.readOnly === 'string' ? (this.props.handleEval(field.readOnly as string)) : false;
        const isNotNewHasKey = (!entity.IsNew && field.isKey)
        const isNewIsDynamicGrid = (entity.IsNew && field.type == "is-dynamic-grid");
        return notNewCantWrite
            || isBoolReadOnly
            || isFunctionReadOnly
            || isNotNewHasKey
            || isNewIsDynamicGrid;
    }

    private renderRequired() {
        const field = this.props.field;
        if (this.props.field.type == "is-panelbar-details") {
            return false;
        }
        const func: Function = field.required as Function;
        const appData = { entity: this.props.entity };

        return (typeof (func) == "function" && func(appData)) || (typeof (field.required) !== "string" && field.required) || (field.required !== false && (this.props.handleEval(field.required as string)))
    }


    private renderTextBox(field, value) {
        return (
            <TextBox field={this.props.field} value={value} context={this.props.context}
                onChange={this.handleOnChange}
                disabled={this.renderDisabled()} required={this.renderRequired()} />
        );
    }

    private renderNachschlag() {
        return (
            <>
                <EditNachschlag field={this.props.field as any} />
            </>
        );
    }

    private rederEmailTextBox(field: BaseField, value: any) {
        return (
            <EmailTextBox field={this.props.field} value={value} context={this.props.context}
                onChange={this.handleOnChange}
                disabled={this.renderDisabled()} required={this.renderRequired()} />
        );
    }

    private renderTranslationTextBox(field, value: []) {
        return (
            <TranslationTextBox
                field={this.props.field}
                value={value}
                context={this.props.context}
                onChange={this.handleOnChange}
                disabled={this.renderDisabled()}
                required={this.renderRequired()}
                language={field.language}
                translation={field.translation}
                multiLine={Helper.getValueOrDefault(field.multiLine, false)}
                maxLength={field.maxLength}
            />
        );
    }

    private renderCheckBox(field, value) {
        return (
            <CheckBox field={this.props.field} value={value} context={this.props.context}
                onChange={this.props.onChange}
                disabled={this.renderDisabled()} required={this.renderRequired()} />
        );
    }

    private renderComboBox(field, value, onDataLoaded, handleEval) {
        return (
            <ComboBox field={this.props.field as ComboBoxField} value={value} dataSource={this.props.dataSource} context={this.props.context}
                onChange={this.handleOnChange} onDataLoaded={onDataLoaded}
                handleEval={handleEval}
                disabled={this.renderDisabled()} commandManager={this.props.commandManager} required={this.renderRequired()} />
        );
    }

    private renderNumericTextBox(field, value, handleEval) {
        return (
            <IsNumericTextBox field={this.props.field as NumericTextBoxField} value={value} context={this.props.context} handleEval={handleEval}
                onChange={this.handleOnChange}
                disabled={this.renderDisabled()} required={this.renderRequired()} />
        );
    }

    private renderDatePicker(field, value) {
        return (
            <DatePicker field={this.props.field} value={value} context={this.props.context}
                onChange={this.props.onChange}
                disabled={this.renderDisabled()} required={this.renderRequired()} />
        );
    }

    private renderDateTimePicker(field, value, handleEval) {
        return (
            <DateTimePicker field={this.props.field} value={value} context={this.props.context}
                onChange={this.handleOnChange} handleEval={handleEval}
                disabled={this.renderDisabled()} required={this.renderRequired()} />
        );
    }

    private handleOnChange = (field, value, dataItem?) => {
        const that = this;
        var nl = document.getElementsByName(field.model);
        if (nl.length == 1) {
            var validator = ($(nl[0]) as any).form().data("kendoValidator");
            validator?.validateInput(nl[0]);
        }
        that.props.onChange(field, value, dataItem);
    }

    private renderIsSearchField(field, value, handleEval, handleIsSearchFieldFullObjectModel, multiSelectMode) {
        return (
            <IsSearchField field={this.props.field as IsSearchFieldField} value={value} context={this.props.context}
                onChange={this.handleOnChange} handleEval={handleEval} handleIsSearchFieldFullObjectModel={handleIsSearchFieldFullObjectModel}
                multiSelectMode={multiSelectMode} commandManager={this.props.commandManager}
                disabled={this.renderDisabled()} required={this.renderRequired()} />
        );
    }

    private renderIsMultipleRadioButtons(field, value, handleEval, onDataLoaded) {
        return (
            <MultipleRadioButtons field={this.props.field as MultipleRadioButtonsField} value={value} dataSource={this.props.dataSource} context={this.props.context}
                onChange={this.props.onChange} onDataLoaded={onDataLoaded}
                disabled={this.renderDisabled()} required={this.renderRequired()} handleEval={handleEval} />
        );
    }

    private renderIsPanelbarDetails(field, value, handleEval, onDataLoaded) {
        return (
            <IsPanelbarDetails field={this.props.field as IsPanelbarDetailsField} value={value} context={this.props.context}
                onDataLoaded={onDataLoaded} commandManager={this.props.commandManager} handleEval={handleEval} />
        );
    }

    private renderDropDownList(field, value, onDataLoaded, handleEval) {
        return (
            <DropDownList field={this.props.field as DropDownListField} value={value} dataSource={this.props.dataSource} context={this.props.context}
                onChange={this.handleOnChange} onDataLoaded={onDataLoaded}
                handleEval={handleEval}
                disabled={this.renderDisabled()} commandManager={this.props.commandManager} required={this.renderRequired()} />
        );
    }

    private renderProgressBar(field, value) {
        return (
            <ProgressBar field={this.props.field as ProgressBarField} value={value}
                onChange={this.props.onChange} />
        );
    }
    private renderNodaPeriodeNumericTextBox(field, value) {
        return (
            <NodaPeriodeNumericTextBox field={this.props.field as NodaPeriodeNumericTextBoxField} value={value}
                onChange={this.handleOnChange} />
        );
    }
    private renderHiddenMemo(field, value) {
        return (
            <HiddenMemo field={this.props.field as BaseField} value={value}
                onChange={this.handleOnChange} />
        );
    }
    private renderMultiSelect(field, value, onDataLoaded) {
        return (
            <MultiSelect field={this.props.field as MultiSelectField} value={value} dataSource={this.props.dataSource} context={this.props.context}
                onChange={this.handleOnChange} onDataLoaded={onDataLoaded}
                disabled={this.renderDisabled()} commandManager={this.props.commandManager} required={this.renderRequired()} />
        );
    }
    private renderListBox(field, value, onDataLoaded) {
        return (
            <ListBox field={this.props.field as ListBoxSelectField} value={value} dataSource={this.props.dataSource} context={this.props.context}
                onChange={this.handleOnChange} onDataLoaded={onDataLoaded}
                disabled={this.renderDisabled()} required={this.renderRequired()} />
        );
    }

    private renderIsGrid(field, value) {
        return (
            <IsGrid field={this.props.field as IsGridField} value={value} context={this.props.context} onChange={this.props.onChange} disabled={this.renderDisabled()} />
        );
    }

    private renderLabel(field, value, handleEval) {
        return (
            <Label field={this.props.field} value={value} context={this.props.context} disabled={this.renderDisabled()} handleEval={handleEval} />
        );
    }

    private renderIsTimeTextBox(field, value) {
        return (
            <IsTimeTextBox field={this.props.field as TimeTextBoxField} value={value} context={this.props.context}
                onChange={this.handleOnChange}
                disabled={this.renderDisabled()} required={this.renderRequired()} />
        );
    }

    private renderIsMultipleCheckBoxes(field, value, onDataLoaded) {
        return (
            <MultipleCheckBoxes field={this.props.field as MultipleCheckBoxesField} value={value} dataSource={this.props.dataSource} context={this.props.context}
                onChange={this.handleOnChange} onDataLoaded={onDataLoaded}
                disabled={this.renderDisabled()} required={this.renderRequired()} />
        );
    }

    private renderTimePicker(field, value) {
        return (
            <TimePicker field={this.props.field} value={value} context={this.props.context}
                onChange={this.handleOnChange} disabled={this.renderDisabled()} required={this.renderRequired()} />
        );
    }

    private renderGetNextNumber(field, value, onDataLoaded, handleEval) {
        return (
            <GetNextNumber field={this.props.field as GetNextNumberField} value={value} context={this.props.context} handleEval={handleEval}
                onChange={this.handleOnChange} onDataLoaded={onDataLoaded}
                disabled={this.renderDisabled()} required={this.renderRequired()} />
        );
    }

    private renderColorPicker(field, value) {
        return (
            <ColorPicker field={this.props.field} value={value} context={this.props.context}
                onChange={this.handleOnChange}
                disabled={this.renderDisabled()} required={this.renderRequired()} />
        );
    }

    private renderHTMLEditor(field, value) {
        return (
            <HTMLEditor field={this.props.field} value={value} context={this.props.context}
                onChange={this.props.onChange} disabled={this.renderDisabled()} commandManager={this.props.commandManager} required={this.renderRequired()} />
        );
    }

    private renderDynamic(field, value, handleEval) {
        const cProps = { field: field, value: value, context: this.props.context, onChange: this.handleOnChange, disabled: this.renderDisabled(), dataSource: this.props.dataSource };
        return <Dynamic componentName={field.componentName} moduleName={field.moduleName} appName={field.appName} customProps={cProps} commandManager={this.props.commandManager}
            context={this.props.context} entity={this.props.entity} handleEval={handleEval} actionCallbacks={this.props.actionCallbacks} />
    }

    private renderStatistic(field, value, handleEval) {
        return <Statistic field={this.props.field as StatisticField} value={value} context={this.props.context} disabled={this.renderDisabled()} 
                          handleEval={handleEval} commandManager={this.props.commandManager} />
    }

    private renderSortableList(field, value, handleEval) {
        return <SortableList field={this.props.field as SortableListField} onChange={this.props.onChange}
            value={value} context={this.props.context} disabled={this.renderDisabled()} handleEval={handleEval} />
    }

    private renderImageDocument(field, value) {
        return <ImageDocument field={this.props.field as ImageDocumentField} onChange={this.props.onChange}
            value={value} context={this.props.context} disabled={this.renderDisabled()} />
    }

    private renderIsDynamicGrid(field, value, onDataLoaded, handleEval) {
        return (
            <DynamicGrid field={this.props.field as DynamicGridField} value={value} context={this.props.context}
                onChange={this.handleOnChange} onDataLoaded={onDataLoaded} handleEval={handleEval}
                disabled={this.renderDisabled()} required={this.renderRequired()} />
        );
    }

    private renderCheckBoxStatus(field, value) {
        return (
            <CheckBoxStatus field={this.props.field} value={value} />
        );
    }
    private renderMaskedInput(field, value) {
        return (
            <MaskedInput field={this.props.field as MaskedInputField} value={value} context={this.props.context}
                onChange={this.handleOnChange} disabled={this.renderDisabled()} required={this.renderRequired()} />
        )
    }

    private prepareStyle = (jsonStyle: string | {}): React.CSSProperties => {
        if (!Helper.hasValue(jsonStyle)) {
            return null;
        } else if (typeof jsonStyle === "string") {
            if (jsonStyle.trim() === "") {
                return null;
            }
        } else {
            return jsonStyle;
        }
    }

    static isInvisible = (visible: boolean, visibleCondition: string | boolean | Function, handleEval, noSearchResult: boolean, entity) => {
        const func: Function = visibleCondition as Function;
        const appData = { entity: entity };
        return ((noSearchResult) || !((!Helper.hasValue(visibleCondition) || (typeof visibleCondition === 'function' ? func(appData) : handleEval(visibleCondition as string))) && visible === true));
    }

    render() {
        const field = this.props.field;

        let label = field.name;
        if (this.props.field.labelAndControlCombined !== true && field.evalLabel === true) {
            label = this.props.handleEval(field.name);
        }

        const props: FieldInstanceProps = {
            fieldStyle: this.prepareStyle(field.rightContainerStyle),
            hint: field.title,
            label: label,
            labelStyle: this.prepareStyle(field.leftContainerStyle),
            labelLabelStyle: this.prepareStyle(field.labelLabelStyle),
            model: field.model,
            noFieldWrapper: false,
            noLabel: this.props.field.labelAndControlCombined === true,
            validationName: field.type === "is-panelbar-details" ? "" : field.model,
            required: this.renderRequired()
        }

        const fields = this.props.field;


        if (Helper.hasValue(field.dc1) && !Field.isInvisible(true, fields.dc1.visible, this.props.handleEval, false, this.props.entity)) {
            props.dc1 = {
                moduleName: fields.dc1.moduleName,
                customProps: $.extend(fields.dc1.customProps, { fieldModel: this.props.field.model }),
                entity: this.props.entity,
                actionCallbacks: this.props.actionCallbacks,
                appName: fields.dc1.appName,
                commandManager: this.props.commandManager,
                context: this.props.context,
                handleEval: this.props.handleEval
            }
        }

        if (Field.isInvisible(this.props.field.visible, field.visibleCondition, this.props.handleEval, this.props.field.noSearchResult, this.props.entity)) {
            return null;
        }

        return (
            <FieldInstance {...props}>
                {this.renderField()}
            </FieldInstance>
        );
    }
};

const FieldInstance = (props: FieldInstanceProps) => {
    return (
        <div className={"field-instance" + (props.noHover === true ? " no-hover" : "")} data-model={props.model}>
            <div className="field__value" title={props.hint}>
                {
                    props.noLabel ?
                        null :
                        <div className="field__value__label" style={props.labelStyle}>
                            <div style={{ display: "flex" }}>
                                {
                                    props.labelRenderer ?
                                        props.labelRenderer(props.model)
                                        : <label title={props.label} style={props.labelLabelStyle}> {props.label} </label>
                                }
                                <span style={{ margin: "2px" }}>{props.required ? " *" : ""}</span>
                            </div>
                        </div>
                }
                {
                    props.noFieldWrapper ?
                        props.children :
                        <div className="field__value__content" style={props.fieldStyle}>
                            {props.children}
                            {
                                props.validationName ?
                                    <div className="k-invalid-msg" data-for={props.validationName}></div>
                                    : null
                            }
                            {
                                Helper.hasValue(props.dc1) ?
                                    <Dynamic {...props.dc1} customProps={props.dc1.customProps} componentName={props.dc1.componentName} moduleName={props.dc1.moduleName} appName={props.dc1.appName} />
                                    : null
                            }

                        </div>
                }
            </div>
        </div>
    );
}

export { FieldInstance as FieldInstance };


interface FieldInstanceProps {
    children?: React.ReactNode;
    //root
    model?: string;
    hint?: string;
    noHover?: boolean;
    //label
    noLabel?: boolean;
    label?: string;
    labelStyle?: React.CSSProperties;
    labelLabelStyle?: React.CSSProperties;
    //field
    noFieldWrapper?: boolean;
    fieldStyle?: React.CSSProperties;
    validationName?: string;
    required?: boolean;
    dc1?: DynamicProps;
    labelRenderer?: (model: string) => JSX.Element;
}

interface FieldProps extends CommonAppBaseProps {
    field: BaseField;
    dataSource?: any;
}